import React, { Fragment } from 'react';
import { useState, useEffect } from 'react';
import cx from 'classnames/bind';
import { Icon } from 'antd';

const Other = () => {

    return (
        <div>
            <div className={cx("toggle-navigation")}>
                <div onClick={() => window.location = '/brand/other'} className={cx("nav-heading")}>
                    <h3>
                        <span className={cx("sidebar-icon-spacing")}><Icon type="global" /></span>
                        <span className={cx("navigation-title")}>Other</span>
                    </h3>
                </div>
            </div>
       </div>
    );
}

export default Other;